/**
 * A caixa e a categoria que um tratamento isolado com recebimento precisa.
 *
 * ─── PORQUE EXISTE ──────────────────────────────────────────────────────────
 *
 * As duas são procuradas pelo NOME EXACTO — «Clínica» e «Tratamento Isolado».
 * Quando uma não existe, o `find` devolve `undefined` e a linha seguinte faz
 * `.._id`, rebentando com:
 *
 *     Nenhuma sessão foi agendada. Sessão 1: Cannot read properties of
 *     undefined (reading '_id')
 *
 * Aconteceu na Prodente a 26/10/2026, a meio de uma formação: a clínica tinha
 * sido criada sem categorias financeiras e só as caixas é que foram repostas.
 * A mensagem não dizia o que faltava nem onde o resolver, e a clínica inteira
 * ficou sem conseguir agendar tratamentos isolados.
 *
 * ─── DIZER O QUE FALTA É A CORREÇÃO ─────────────────────────────────────────
 *
 * O erro lançado aqui sobe ao `catch` do ciclo das sessões, que o mostra como
 * «Sessão 1: …». Por isso a frase tem de bastar-se a si própria: diz o nome
 * exacto do que falta e onde se cria.
 *
 * ─── ESTÁ AQUI, E NÃO NOS QUATRO SÍTIOS ─────────────────────────────────────
 *
 * São dois formulários — a agenda normal e a de tratamentos — e cada um faz
 * isto duas vezes, ao criar e ao editar. Quatro cópias divergiam à primeira
 * alteração.
 */

export const NOME_CAIXA_CLINICA = "Clínica";
export const NOME_CATEGORIA_TRATAMENTO_ISOLADO = "Tratamento Isolado";

/**
 * Devolve `{ caixa, categoria }` ou lança com uma frase que se explica.
 *
 * @param {{caixas: Array}} caixaRes       resposta de `/api/caixas/clinica/:id`
 * @param {{categoriasFinanceiro: Array}} catRes  resposta de
 *        `/api/categoriasfinanceiro/clinica/entrada/:id`
 */
export const dadosFinanceirosTratamentoIsolado = (caixaRes, catRes) => {
  const caixa = (caixaRes?.caixas || []).find(
    (c) => c.caixa === NOME_CAIXA_CLINICA,
  );
  const categoria = (catRes?.categoriasFinanceiro || []).find(
    (c) => c.categoria === NOME_CATEGORIA_TRATAMENTO_ISOLADO,
  );

  const emFalta = [];
  if (!caixa) emFalta.push(`a caixa «${NOME_CAIXA_CLINICA}»`);
  if (!categoria) {
    emFalta.push(
      `a categoria financeira de entrada «${NOME_CATEGORIA_TRATAMENTO_ISOLADO}»`,
    );
  }

  if (emFalta.length) {
    throw new Error(
      `Falta ${emFalta.join(" e ")} nesta clínica. ` +
        "Crie em Configurações → Caixas e Categorias Financeiras, com o nome " +
        "exactamente assim, e tente de novo.",
    );
  }

  return { caixa, categoria };
};
